const AudienceType = {
  Devices: "Devices",
  Individuals: "Individuals",
};

const SegmentType = {
  Include: "Include",
  Exclude: "Exclude",
};

export { AudienceType, SegmentType };
